<i18n>
  {
    "en": {
      "choose_signin": "Choose a sign in method:"
    },
    "zhHant": {
      "choose_signin": "選擇一種登入方式:"
    },
    "ja": {
      "choose_signin": "ログイン方法をお選びください"
    },
    "ko": {
      "choose_signin": "로그인 방식을 선택하십시오:"
    }
  }
  </i18n>

<template>
  <div>
    <v-container>
      <v-layout column align-center justify-center>
        <div v-if="!isLogin">
          <div>XR-PC</div>
          <div class="subheading mb-3 text-xs-center">
            {{ $t('choose_signin') }}
          </div>
          <div id="firebaseui-auth-container"></div>
        </div>
        <div v-else>
          <div class="subheading mb-3 text-xs-center">Login Successed</div>
          <v-btn :loading="loading" color="success" :href="`xrpc://${token}`" target="_blank">Open XR-PC</v-btn>
          <v-btn v-if="prefixURL != ''" :loading="loading" color="success" :href="`${prefixURL}${token}`"
            target="_blank">
            Open Link
          </v-btn>
        </div>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/functions';
import * as firebaseui from 'firebaseui';
import 'firebaseui/dist/firebaseui.css';

export default {
  name: 'login',
  data: () => {
    return {
      loading: true,
      isLogin: false,
      token: '',
      prefixURL: '',
    };
  },
  async mounted() {
    this.prefixURL = this.$route.query.prefix || '';
    if (firebase.auth().currentUser === null) {
      this.isLogin = false;
      // FirebaseUI config.
      const uiConfig = {
        signInSuccessUrl: '/xrpc-login',
        signInOptions: [
          // Leave the lines as is for the providers you want to offer your users.
          firebase.auth.GoogleAuthProvider.PROVIDER_ID,
          firebase.auth.FacebookAuthProvider.PROVIDER_ID,
        ],
      };
      // Initialize the FirebaseUI Widget using Firebase.
      const ui = firebaseui.auth.AuthUI.getInstance() || new firebaseui.auth.AuthUI(firebase.auth());

      // The start method will wait until the DOM is loaded.
      ui.start('#firebaseui-auth-container', uiConfig);
    } else {
      const result = await firebase.functions().httpsCallable('XRobotmonGroup-xGetPCToken')();
      this.loading = false;
      this.isLogin = true;
      this.token = result.data;

      // Auto redirect when prefixURL is available
      if (this.prefixURL !== '') {
        window.location.href = `${this.prefixURL}${this.token}`;
      }
    }
  },
};
</script>

<style></style>